import { DataTypeValue } from '../../../../../../domain/DataType';

export const hasCo2Columns = (dataTypeValue: DataTypeValue | undefined): boolean =>
  dataTypeValue === 'co2' || dataTypeValue === 'quantity-cost-co2';
